

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _index = require('xo-models/src/address/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/fi/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCardFlow', function () {
    return {
        template: _template2['default'],

        scope: {
            token: '=?',
            parentCallbacks: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            fundingid: '=?',
            showBalanceFlow: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?',
            cardmodel: '=?',
            updateCardCpa: '=?',
            cause: '=?'
        },

        controller: ['$scope', function ($scope) {

            $scope.addCCDone = function () {
                $scope.parentCallbacks.finish();
            };

            $scope.callbacks = {
                done: $scope.parentCallbacks.finish,
                cancel: $scope.parentCallbacks.cancel,
                showCep: function showCep() {
                    $scope.prefillAddress = new _index.$PrefillAddressModel({
                        id: $scope.token
                    });

                    _uiRouter.$state.go('^.addCep');
                },

                cardTypeSelected: function cardTypeSelected(type) {
                    $scope.selectedPromotionCardType = {
                        type: type
                    };
                    _uiRouter.$state.go('^.addCard');
                }
            };

            $scope.cepDone = function () {
                _uiRouter.$state.go('^.addBilling');
            };

            $scope.selectedPromotionCardType = {
                type: $scope.promotion && $scope.promotion.type
            };

            if ($scope.promotion) {
                $scope.promotion.type = null;
            }

            $scope.billingaddressupdated = {
                value: false
            };

            $scope.phone = {
                hide_type: true
            };

            if (!$scope.cardmodel) {
                $scope.cardmodel = new _index3.$AddCardModel({
                    card: new _index3.$CardModel()
                });
            }

            (0, _squid.$populate)($scope, {
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                })
            }).then(function () {

                if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
                    var card = $scope.checkoutSession.errorData.resolution.data;

                    if (card.fundingId && card.fi && card.fi.type) {
                        $scope.cardmodel.id = card.fundingId;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                            type: card.fi.type.toUpperCase(),
                            productType: card.fi.productType
                        });
                    }
                }
                if ($scope.fundingid) {
                    var fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
                        if (funding && funding.id === $scope.fundingid) {
                            return funding;
                        }
                    });

                    if (!fundingSource) {
                        fundingSource = _squid.$util.find($scope.checkoutSession.fundingOptions.disallowedInstruments, function (funding) {
                            if (funding && funding.id === $scope.fundingid) {
                                return funding;
                            }
                        });
                    }

                    if (fundingSource) {
                        $scope.cardmodel.id = fundingSource.id;
                        $scope.cardmodel.card = new _index3.$CardModel({
                            number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                            lastDigits: fundingSource.lastDigits,
                            type: fundingSource.name.toUpperCase(),
                            name: (0, _squid.$renderContent)('fsMappings.' + fundingSource.name)
                        });
                    }
                }
            });
        }]
    };
});

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_index.$PrefillAddressModel;

_index2.$CheckoutSessionModel;

_index3.$AddCardModel;

_index3.$CardModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/directive.js
// module chunks = 0